module.exports = __webpack_public_path__ + "img/heshi.7c7986d9.svg";